/**
 * @generated SignedSource<<e159401bfe641162588c008c3ff7e499>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type shareSongPDFInput = {
  clientMutationId?: string | null;
  shareEmail: string;
  songId: string;
};
export type ShareSongPDFMutation$variables = {
  input: shareSongPDFInput;
};
export type ShareSongPDFMutation$data = {
  readonly shareSongPDF: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AuthError";
      readonly message: string;
    }>;
  } | null;
};
export type ShareSongPDFMutation = {
  response: ShareSongPDFMutation$data;
  variables: ShareSongPDFMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "shareSongPDFPayload",
    "kind": "LinkedField",
    "name": "shareSongPDF",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ShareSongPDFMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShareSongPDFMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "651f37f0778d627741c5d4a5936a07e0",
    "id": null,
    "metadata": {},
    "name": "ShareSongPDFMutation",
    "operationKind": "mutation",
    "text": "mutation ShareSongPDFMutation(\n  $input: shareSongPDFInput!\n) {\n  shareSongPDF(input: $input) {\n    errors {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6e7953ce64d1a93c29b1399a4dd93154";

export default node;
